import React, { useEffect } from 'react';
import Advisor from './Advisor';
import Loader from "../Loader";
import { createDataTestId, AutomationPlacement, AutomationTestIdFeature, AutomationTestIdElementType } from '../../utilities/automation';

export default function AdvisorGrid({ advisors, virtualAdvisors, isLoading, isSearch, radius, address }) {

    const hasAdvisors = advisors.length > 0;
    const renderAdvisors = !hasAdvisors && isSearch ? virtualAdvisors : advisors;

    function showError() {
        if (isSearch && !hasAdvisors) {
            return (<div className="text-center text-primary py-4"><strong>We're sorry, no Wealth Advisors are available within {radius} miles of {address}.<br />
            Please try expanding your search distance or consult one of our virtual advisors.</strong></div>);
        }
    }

    useEffect(() => {
        if (!isLoading && renderAdvisors.length > 0) {
            const scriptId = "onceHubScript";
            const script = document.createElement('script');
            document.getElementById(scriptId)?.remove();
            script.id = scriptId;
            script.src = "https://cdn.oncehub.com/mergedjs/so.js";
            document.body.appendChild(script);

        }
    }, [isLoading]);

    return (
        <div className="position-relative" style={{minHeight: '100px'}}>
            <Loader spinner={isLoading} top={10} width={4} height={4} variant="secondary" />
            {showError()}
            {!isLoading && <div className="row h-100 py-4" data-test-id={createDataTestId({feature: AutomationTestIdFeature.WEALTH_ADVISOR_LOOKUP, element: AutomationTestIdElementType.COLLECTION})}>
                {renderAdvisors.map(advisor => <Advisor key={advisor.CodeName || advisor.codeName} {...advisor} />)}
            </div>}
        </div>
    );
}
